import './standings.styles.scss';
import { Link } from 'react-router-dom';
import TeamBadge from '@/components/SHARED/team-badge/team-badge.component';
import TeamName from '@/components/SHARED/team-name/team-name.component';
import { streakText } from '@/utils/leagueLabels';
import PrestigeStars from '@/components/SHARED/prestige-stars/prestige-stars.component';
import { conferencePrestige } from '@shared/prestige.js';

// Conference standings. teams: summary/teams `teams` map.
// teamLink(teamId) -> path for each team's page. highlightId: a team to
// mark (the manager's own).
const Standings = ({ league, teams, teamLink, highlightId }) => {

    if (!league || !teams) return null;

    const pct = (w, l) => (w + l ? w / (w + l) : 0);
    // The highlighted team's conference comes first.
    const mine = (c) => (c.teamIds.includes(highlightId) ? 0 : 1);
    const conferences = Object.values(league.conferences)
        .sort((a, b) => mine(a) - mine(b) || a.name.localeCompare(b.name));
    // College conferences show their prestige: the average of their teams'.
    const prestige = league.type !== 'pro' ? conferencePrestige(Object.values(teams)) : null;

    return (
        <div className='standings'>
            {conferences.map(conf => {
                const rows = conf.teamIds
                    .map(id => teams[id])
                    .filter(Boolean)
                    .sort((a, b) => {
                        const ra = a.record;
                        const rb = b.record;
                        return pct(rb.confW, rb.confL) - pct(ra.confW, ra.confL) ||
                            pct(rb.w, rb.l) - pct(ra.w, ra.l) ||
                            (rb.pf - rb.pa) - (ra.pf - ra.pa) ||
                            a.name.localeCompare(b.name);
                    });
                return (
                    <section key={conf.id} className='g-card standings-conference'>
                        <h3>
                            {conf.name}
                            {prestige?.[conf.id] && <PrestigeStars value={prestige[conf.id]} label='Conference prestige' />}
                        </h3>
                        <div className='table-scroll'>
                            <table className='g-table standings-table'>
                                <thead>
                                    <tr>
                                        <th className='team-col'>Team</th>
                                        <th className='num'>Conf</th>
                                        <th className='num'>Overall</th>
                                        <th className='num wide-only'>Home</th>
                                        <th className='num wide-only'>Away</th>
                                        <th className='num'>Strk</th>
                                        <th className='num wide-only'>Last 10</th>
                                        <th className='num wide-only'>Diff</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map(t => {
                                        const r = t.record;
                                        const recent = r.recent ?? [];
                                        const diff = r.pf - r.pa;
                                        return (
                                            <tr key={t.id} className={t.id === highlightId ? 'highlight' : ''}>
                                                <td className='team-col'>
                                                    <Link to={teamLink(t.id)} className='team-link'>
                                                        <TeamBadge team={t} size='sm' />
                                                        <span><TeamName team={t} /></span>
                                                    </Link>
                                                </td>
                                                <td className='num'>{r.confW}-{r.confL}</td>
                                                <td className='num'>{r.w}-{r.l}</td>
                                                <td className='num wide-only'>{r.homeW}-{r.homeL}</td>
                                                <td className='num wide-only'>{r.awayW}-{r.awayL}</td>
                                                <td className='num'>{streakText(r.streak)}</td>
                                                <td className='num wide-only'>{recent.filter(x => x === 'W').length}-{recent.filter(x => x === 'L').length}</td>
                                                <td className='num wide-only'>{diff > 0 ? `+${diff}` : diff}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </section>
                )
            })}
        </div>
    )
}

export default Standings
